export default "__VITE_ASSET__54dc1853__"